import React from 'react'
import { Box, Container, Image, Text } from '@mantine/core'
import classes from '../../../pages/Home/Home.module.css'
import Carousel from 'react-multi-carousel'
import "react-multi-carousel/lib/styles.css"
import '../../../assets/css/slidercustom.css'
import PetLogo from '../../../assets/img/LogoPartnerNew/1. PET.png'
import ItsTeknoLogo from '../../../assets/img/LogoPartnerNew/2. ITS TEKNO.png'
import ItsLogo from '../../../assets/img/LogoPartnerNew/3. ITS.png'
import DkpuLogo from '../../../assets/img/LogoPartnerNew/4. DKPU.png'
import LspLogo from '../../../assets/img/LogoPartnerNew/5. LSP Lalinsa.png'
import TandeemLogo from '../../../assets/img/LogoPartnerNew/6. TANDEEM.png'
import PertaminaLogo from '../../../assets/img/LogoPartnerNew/7. PERTAMINA.png'
import PlnLogo from '../../../assets/img/LogoPartnerNew/8. PLN.png'
import AsahimasLogo from '../../../assets/img/LogoPartnerNew/9. ASAHIMAS.png'
import PremierOilLogo from '../../../assets/img/LogoPartnerNew/10. PREMIER OIL.png'
import KidecoLogo from '../../../assets/img/LogoPartnerNew/11. KIDECO.png'
import KangeanLogo from '../../../assets/img/LogoPartnerNew/12. KANGEAN.png'
import PetrokimiaLogo from '../../../assets/img/LogoPartnerNew/13. PETROKIMIA.png'
import ValeLogo from '../../../assets/img/LogoPartnerNew/14. VALE.png'
import MhpLogo from '../../../assets/img/LogoPartnerNew/15. MHP.png'
import MedcoLogo from '../../../assets/img/LogoPartnerNew/16. MEDCO.png'
import AdarcoLogo from '../../../assets/img/LogoPartnerNew/17. ADARO.png'
import OtsukaLogo from '../../../assets/img/LogoPartnerNew/18. OTSUKA.png'
import KomatsuLogo from '../../../assets/img/LogoPartnerNew/19. KOMATSU.png'
import IkppLogo from '../../../assets/img/LogoPartnerNew/20. IKPP.png'
import AtramentumLogo from '../../../assets/img/LogoPartnerNew/21. Logo HMTL Atramentum.png'
import UnairLogo from '../../../assets/img/LogoPartnerNew/22. Logo UNAIR.png'
import PpnsLogo from '../../../assets/img/LogoPartnerNew/23. PPNS (2).png'
import UpnLogo from '../../../assets/img/LogoPartnerNew/24. HMTL UPN.png'





const PartnerSection = () => {

  const defaultResponsive = {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024
      },
      items: 9,
      partialVisibilityGutter: 40
    },
    mobile: {
      breakpoint: {
        max: 464,
        min: 0
      },
      items: 1,
      partialVisibilityGutter: 50
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 464
      },
      items: 3,
      partialVisibilityGutter: 30
    }
  }

  
  return (
    <Box className={classes.bgGraySection}>
      <Container fluid className={classes.section}>
        <Box className={classes.paddingPage} align="center">
          <Text className={classes.titleSection} mb={8}>Partner</Text>
          <Text fz="lg" mb={50}>yang telah mendukung dan menggunakan Jasa Pelatihan Kami</Text>
        </Box>
      </Container>
      <Carousel
        arrows={false}
        // swipeable
        autoPlay={true}
        autoPlaySpeed={3000}
        responsive={defaultResponsive}
        centerMode={true}
        infinite={true}
        // partialVisible={true}
      >
        <Box>
          <Image h={50} fit='contain' src={PetLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={ItsTeknoLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={ItsLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={PremierOilLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={DkpuLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={TandeemLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={LspLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={PertaminaLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={AdarcoLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={PlnLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={KidecoLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={KangeanLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={KomatsuLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={PetrokimiaLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={ValeLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={MedcoLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={OtsukaLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={AtramentumLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={IkppLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={UnairLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={MhpLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={PpnsLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={AsahimasLogo} />
        </Box>
        <Box>
          <Image h={50} fit='contain' src={UpnLogo} />
        </Box>
      </Carousel>
    </Box>
  )
}

export default PartnerSection